import { Button } from "../../components/ui/button";
import Common from "../../helper/common";
import {
    ResultStatus,
} from "../../constants/appConstant";
import { AppCheckBox } from "../../components/appComponents";
import CardSnippet from "../../components/ui/card-snippet";
import { CardContent } from "../../components/ui/card";
import { AppSearchSelect } from "../../components/appComponents";
import { useEffect, useState } from "react";
import AddGlobalRole from "./addGlobalRole";

const GlobalPermissions = () => {

    const [roleList, setRoleList] = useState([]);
    const [permissionsList, setPermissionsList] = useState([]);
    const [defaultPermissionsList, setDefaultPermissionsList] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);
    const [open, setOpen] = useState(false);
    const [selectedRoleId, setSelectedRoleId] = useState(null);
    const [checkedPermissions, setCheckedPermissions] = useState(new Set());
    const [saving, setSaving] = useState(false);
    const [defaultViewId, setDefaultViewId] = useState(null);
    const [roleDropdownKey, setRoleDropdownKey] = useState(0);

    useEffect(() => {
        getGlobalRoles();
        getDefaultPermissions();
        //getPermissions();
    }, []);

    const getDefaultPermissions = async () => {

        const response = await Common.ApiService.getInstance().request(
            `GetDefaultGlobalPermissions`,
            "GET"
        );
        const _data = response?.data ?? [];
        setDefaultPermissionsList(_data);
        const defaultView = _data.find(p => p.isdefaultview === 1);
        setDefaultViewId(defaultView ? defaultView.id : null);
    };

    const getGlobalRoles = async () => {
        try {
            const response = await Common.ApiService.getInstance().request(
                `GetGlobalRoles`,
                "GET"
            );
            const data = response?.data ?? [];
            setRoleList(data);
            return data;
        } catch (err) {
            console.error("getRolesByClub error:", err);
            throw err;
        }
    };

    const getPermissionsByRole = async (roleId = null) => {
        let queryParams = [];

        if (roleId) queryParams.push(`roleId=${roleId}`);

        const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
        debugger
        const response = await Common.ApiService.getInstance().request(
            `GetPermissionsForRoles${queryString}`,
            "GET"
        );
        const _data = response?.data ?? [];
        setPermissionsList(_data);

        // Identify the checked IDs
        const checkedIds = new Set(_data.map(p => p.id));
        setCheckedPermissions(checkedIds);

        const defaultView = _data.find(p => p.isdefaultview == 1);
        setDefaultViewId(defaultView ? defaultView.id : null);
    };

    const handleClose = () => {
        getGlobalRoles();
    };

    // Handle individual checkbox change
    const handlePermissionChange = (permissionId, isChecked) => {
        const newCheckedPermissions = new Set(checkedPermissions);

        if (isChecked) {
            newCheckedPermissions.add(permissionId);
        } else {
            newCheckedPermissions.delete(permissionId);

            // Clear defaultview and premiumallowed on unselect
            const updated = permissionsList.map(p => {
                if (p.id === permissionId) {
                    return {
                        ...p,
                        isdefaultview: 0,
                        premiumallowed: null,
                    };
                }
                return p;
            });
            setPermissionsList(updated);

            // If the unselected permission was the default view, clear defaultViewId
            if (defaultViewId === permissionId) {
                setDefaultViewId(null);
            }
        }

        setCheckedPermissions(newCheckedPermissions);
    };


    // Handle parent checkbox change (recursive)
    const handleParentPermissionChange = (node, isChecked) => {
        const newCheckedPermissions = new Set(checkedPermissions);

        // Function to recursively add/remove node and all children
        const updateNodeAndChildren = (currentNode, checked) => {
            if (checked) {
                newCheckedPermissions.add(currentNode.id);
            } else {
                newCheckedPermissions.delete(currentNode.id);
            }

            // Recursively handle children
            if (currentNode.children && currentNode.children.length > 0) {
                currentNode.children.forEach(child => {
                    updateNodeAndChildren(child, checked);
                });
            }
        };

        updateNodeAndChildren(node, isChecked);
        setCheckedPermissions(newCheckedPermissions);
    };

    // Save permissions function
    const savePermissions = async () => {
        if (!selectedRole) {
            Common.showToast("Please select a club and role first.", "Warning", "warning");
            return;
        }
        if (checkedPermissions.size === 0) {
            Common.showToast("Please select at least one permission.", "Warning", "warning");
            return;
        }
        if (!defaultViewId) {
            Common.showToast("Please select a Default View before saving.", "Warning", "warning");
            return;
        }
        setSaving(true);

        try {
            // Convert Set to Array
            const selectedPermissionIds = Array.from(checkedPermissions);

            // Prepare data for API call
            const payload = {
                roleid: selectedRoleId,
                menuIds: selectedPermissionIds,
                defaultviewId: defaultViewId,
            };
            // Option 1: Using batch save (recommended)
            const response = await Common.ApiService.getInstance().request(
                "SaveGlobalPermissions",
                payload,
                "POST"
            );

            if (response.status === ResultStatus.Success || response.success) {
                Common.showToast("Permissions saved successfully!", "Success", "success");
                getPermissionsByRole(selectedRoleId);
            } else {
                Common.showToast("Error saving permissions: " + (response.message || "Unknown error", "Error", "error"));
            }

        } catch (error) {
            console.error("Error saving permissions:", error);
            Common.showToast("Error saving permissions: " + error.message, "Error", "error");
        } finally {
            setSaving(false);
        }
    };

    const buildPermissionTree = (flatList) => {
        const map = {};
        const tree = [];

        flatList.forEach((item) => {
            map[item.id] = { ...item, children: [] };
        });

        flatList.forEach((item) => {
            if (item.parentId && map[item.parentId]) {
                map[item.parentId].children.push(map[item.id]);
            } else {
                tree.push(map[item.id]);
            }
        });

        const sortByOrder = (list) => {
            return list
                .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
                .map((node) => ({
                    ...node,
                    children: sortByOrder(node.children),
                }));
        };

        return sortByOrder(tree);
    };

    //Helper function to count children recursively
    const countChildren = (node) => {
        if (!node.children || node.children.length === 0) {
            return 0;
        }

        let count = node.children.length;
        node.children.forEach(child => {
            count += countChildren(child);
        });

        return count;
    };

    // Check if all children are selected
    const areAllChildrenSelected = (node) => {
        if (!node.children || node.children.length === 0) {
            return checkedPermissions.has(node.id);
        }

        return node.children.every(child =>
            checkedPermissions.has(child.id) && areAllChildrenSelected(child)
        );
    };

    // Check if some children are selected (for indeterminate state)
    const areSomeChildrenSelected = (node) => {
        if (!node.children || node.children.length === 0) {
            return false;
        }

        return node.children.some(child =>
            checkedPermissions.has(child.id) || areSomeChildrenSelected(child)
        );
    };

    const renderPermissions = (nodes, level = 0) => {
        if (!nodes || nodes.length === 0 || nodes.every(n => !n?.name)) {
            return (
                <div className="text-gray-500 text-sm text-center">
                    No permissions found...
                </div>
            );
        }

        // Compute Select All checkbox state only at top-level
        const allPermissionIds = nodes.flatMap(n => {
            const gatherIds = (node) => {
                let ids = [node.id];
                if (node.children && node.children.length > 0) {
                    node.children.forEach(child => {
                        ids = ids.concat(gatherIds(child));
                    });
                }
                return ids;
            };
            return gatherIds(n);
        });
        const isAllSelected = allPermissionIds.length > 0 && allPermissionIds.every(id => checkedPermissions.has(id));
        const isIndeterminate = checkedPermissions.size > 0 && !isAllSelected;

        return nodes.map((node) => {
            const paddingStyle = {
                paddingLeft: `${level * 20}px`,
            };

            const childCount = countChildren(node);
            const premiumLabel = node.ispremium ? " (Premium Feature)" : "";
            const displayText =
                childCount > 0
                    ? `${node.name} ---------------- (${childCount})${premiumLabel}`
                    : `${node.name}${premiumLabel}`;

            const isChecked = checkedPermissions.has(node.id);
            const hasChildren = node.children && node.children.length > 0;
            const allChildrenSelected = hasChildren
                ? areAllChildrenSelected(node)
                : false;
            const someChildrenSelected = hasChildren
                ? areSomeChildrenSelected(node)
                : false;

            return (
                <div
                    key={node.id}
                    className="py-1 flex flex-col sm:flex-row sm:items-center sm:justify-between border-b border-dashed border-gray-200"
                >
                    {/* Left: Permission checkbox */}
                    <div className="flex items-center gap-2 w-full sm:w-3/4" style={paddingStyle}>
                        <AppCheckBox
                            text={displayText}
                            checked={hasChildren ? allChildrenSelected : isChecked}
                            indeterminate={hasChildren && someChildrenSelected && !allChildrenSelected}
                            onChange={(checked) => {
                                if (hasChildren) {
                                    handleParentPermissionChange(node, checked);
                                } else {
                                    handlePermissionChange(node.id, checked);
                                }
                            }}
                            className="border-default-300"
                        />
                    </div>

                    {/* Right: Default view toggle (radio-style) */}
                    {!hasChildren && (
                        <div className="flex items-center gap-2 text-sm text-muted-foreground pr-4 mt-2 sm:mt-0">
                            <span className="text-xs text-gray-500">Default View</span>
                            <input
                                type="radio"
                                name="defaultView"
                                checked={defaultViewId === node.id}
                                onChange={() => {
                                    // select the item if not selected
                                    if (!checkedPermissions.has(node.id)) {
                                        const newChecked = new Set(checkedPermissions);
                                        newChecked.add(node.id);
                                        setCheckedPermissions(newChecked);
                                    }

                                    const updated = permissionsList.map((p) => ({
                                        ...p,
                                        isdefaultview: p.id === node.id ? 1 : 0,
                                    }));
                                    setPermissionsList(updated);
                                    setDefaultViewId(node.id);
                                }}
                                className="form-radio h-4 w-4 text-primary"
                            />
                        </div>
                    )}

                    {/* Recursively render children */}
                    {hasChildren && (
                        <div className="w-full">{renderPermissions(node.children, level + 1)}</div>
                    )}
                </div>
            );
        });
    };

    const permissionTree = buildPermissionTree(defaultPermissionsList);
    // Select All logic
    const allPermissionIds = defaultPermissionsList.map(p => p.id);
    const isAllSelected = allPermissionIds.length > 0 && allPermissionIds.every(id => checkedPermissions.has(id));
    const isIndeterminate = checkedPermissions.size > 0 && !isAllSelected;

    const handleSelectAllChange = (checked) => {
        if (checked) {
            setCheckedPermissions(new Set(allPermissionIds));
        } else {
            setCheckedPermissions(new Set());
        }
    };

    return (
        <>
            <div className="md:grid md:grid-cols-6 gap-3 h-150 w-150 ">
                <AppSearchSelect
                    key={roleDropdownKey}
                    id="roleDropdown"
                    value={selectedRole}
                    onChange={async (val) => {
                        setSelectedRole(val);
                        setSelectedRoleId(val || null);

                        if (val) {
                            await getPermissionsByRole(val);
                        }
                    }}
                    placeholder="Select Role"
                    label="Roles"
                    data={roleList}
                    className="mb-3 col-span-1"
                />

                <Button className="lg:mt-6 h-8 mb-5" onClick={() => {
                    setOpen(true);
                }}>
                    Add Role
                </Button>
            </div>
            <div className="flex flex-col gap-2">
                <CardSnippet
                    title="Global Permissions"
                    addButton={() => (
                        <Button className="h-8" onClick={savePermissions}
                            disabled={saving || !selectedRole}>
                            Save Permissions
                        </Button>
                    )}
                >
                    <CardContent className="p-4">
                        {defaultPermissionsList && defaultPermissionsList.length > 0 && defaultPermissionsList.some(n => n?.name) && (
                            <>
                                <div className="mb-4">
                                    <AppCheckBox
                                        text={<span className="font-bold text-md">Select All Permissions</span>}
                                        checked={isAllSelected}
                                        indeterminate={isIndeterminate}
                                        onChange={handleSelectAllChange}
                                        className="border-default-300 w-6 h-6"
                                    />
                                </div>
                                <hr className="border-gray-300 mb-4" />
                            </>
                        )}
                        {renderPermissions(permissionTree)}
                    </CardContent>
                </CardSnippet>
            </div>

            {/* Initialize the dialog */}
            <AddGlobalRole
                open={open}
                setOpen={setOpen}
                onClose={handleClose}
            />
        </>
    );
};

export default GlobalPermissions;